import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule, } from 'jk-service';

@Component({
  standalone: true,
  imports: [MaterialModule],
  selector: 'app-record-bar',
  templateUrl: './record-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./record-bar.component.scss'],
})
export class RecordBarComponent  implements OnInit {
  @Input()  cbUIEdit?: (item: any) => void;
  @Input()  cbDetail?: (item: any) => void;
  @Input()  cbUIDelete?: (item: any) => void;
  @Input()  public editVisible = true;
  @Input()  public detailVisible = true;
  @Input()  public deleteVisible = true;
  @Input() public item: any;

  constructor() {

  }

  ngOnInit() {

  }
  gotoDetail(){
    if(this.cbDetail)
    this.cbDetail(this.item);
  }
  doUIEdit(){
    if(this.cbUIEdit)
    this.cbUIEdit(this.item);
  }
  doUIDelete(){
    if(this.cbUIDelete)
    this.cbUIDelete(this.item);
  }

}
